import Vue from 'vue';
import {
  LIST,
  ADVERTISER,
} from './mutation-types';

export default {

  [LIST](state, response) {
    state.company = response.company;
    state.total = response.totalCnt;
  },

  [ADVERTISER](state, response) {
    state.advertisers = response.company;
  },

};
